'use client'

import { ReactNode } from 'react'
import { Spacer, Text, Image } from '@vinted/web-ui'

type Props = {
  label?: string
  messages?: Array<ReactNode>
  showSpacer?: boolean
  reportImage?: string
  avatarImageSrc?: string
  withBackground?: boolean
}

const ConversationExample = ({
  label,
  messages = [],
  showSpacer = true,
  reportImage,
  avatarImageSrc,
  withBackground = false,
}: Props) => {
  const renderMessage = (message: ReactNode, index: number) => (
    <div key={index} className="phishing-first-time-lister-education__message">
      {message}
    </div>
  )

  if (reportImage) {
    return <Image src={reportImage} alt="Report example" scaling="contain" />
  }

  return (
    <>
      {label && <Text as="span" text={label} type="body" bold />}
      {showSpacer && <Spacer size="large" />}
      <div
        className={`phishing-first-time-lister-education__conversation${
          withBackground
            ? ' phishing-first-time-lister-education__conversation--with-background'
            : ''
        }`}
      >
        {avatarImageSrc && (
          <div className="phishing-first-time-lister-education__avatar">
            <Image src={avatarImageSrc} styling="circle" size="medium" />
          </div>
        )}
        <div className="phishing-first-time-lister-education__messages-container">
          {messages.map(renderMessage)}
        </div>
      </div>
    </>
  )
}

export default ConversationExample
